/** The page the bank sends the customer back to. */
export default {
  titles: {
    loading: "Confirming your payment…",
    success: "Payment successful",
    failed: "Payment not completed",
    error: "Something went wrong",
  },
  messages: {
    cancelled: "Your payment was not completed and no charges were made.",
    unmatched:
      "{{bank}} returned a result we couldn't match to an order. If you were charged, contact support.",
    noInfo: "No payment information was found.",
    stillConfirming: "{{bank}} is still confirming your payment…",
    notFound:
      "We have no record of a completed payment for this order, so nothing was charged. You can try again.",
    notConfirmedYet:
      "{{bank}} has not confirmed your payment yet. You can close this page — we keep checking, and your points are added as soon as it is confirmed.",
    declinedWithReason: "Your payment was not completed: {{reason}}.",
    declinedWithReasonCode: "Your payment was not completed: {{reason}} (status {{code}}).",
    declined: "Your payment was declined or not completed.",
    declinedCode: "Your payment was declined or not completed (status {{code}}).",
    activatedGuest:
      "Your plan has been activated. Create an account (or sign in) with the email you used at checkout to use your points.",
    alreadyConfirmed: "This payment was already confirmed and your points are active.",
    authorised:
      "Your payment is authorised and your points have been added. The charge settles shortly.",
    activated: "Your plan has been activated and points have been added.",
    verifyFailed:
      "We couldn't confirm your payment: {{reason}} If you were charged, contact support with order {{orderId}}.",
  },
  receipt: {
    title: "Your receipt",
    emailed: "We have emailed your receipt to the address you entered at checkout. You can also download it here.",
  },
  createAccount: "Create account",
  goToProfile: "Go to profile",
};
